import { settleRefreshes } from '@shared/api';
import { buildHandoffUrl } from '@shared/auth/session-coordination';
import { useAuthStore } from '@shared/store/auth.store';

/**
 * Open another HEXAUNITY application in THIS tab, continuing the Identity
 * session through the existing handoff (`buildHandoffUrl`): the session id —
 * an identifier, never a token — travels in the URL fragment, which is never
 * sent to a server, and the target restores the session from the HttpOnly
 * refresh cookie. No second sign-in, no second authentication system.
 *
 * A refresh still in flight here is awaited first, so the target never
 * presents a refresh cookie rotated by a request this tab abandoned.
 */
export async function openApplication(
  appBaseUrl: string,
  path = '/',
  navigate: (url: string) => void = (url) => window.location.assign(url),
): Promise<void> {
  await settleRefreshes();
  navigate(buildHandoffUrl(appBaseUrl, useAuthStore.getState().activeSessionId, path));
}
